import { Node } from 'tiptap';

export default class CardHeader extends Node {
	get name() {
		return 'card_header'
	}
	get schema() {
		return {
			content: 'text*',
			parseDOM: [{
				tag: 'span.grid-card__header'
			}],
			toDOM: () => [
				'span',
				{
					class: "grid-card__header"
				},
				0
			],
		}
	}
}